// @flow
type TConsole = {
    name?: string,
};

type TConsoleState = {
    data: TConsole,
};
const initialState: TConsoleState = {
    data: {},
    list: [],
};

type TUpdateConsoleList = {payload: TConsole, type: 'UPDATE_CONSOLE_LIST'};

type TConsoleActionList = TUpdateConsoleList;

function consoleReducer(state: TConsoleState = initialState, {type, payload}: TConsoleActionList) {
    switch (type) {
        case 'UPDATE_CONSOLE_LIST':
            return {
                ...state,
                data: payload,
                list: Object.keys(payload).sort((item, nextItem) => {
                    return payload[item].rating - payload[nextItem].rating;
                }),
            };
        default:
            return state;
    }
}

export {consoleReducer};
export type {TConsole, TUpdateConsoleList, TConsoleState};
